// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1sdPo","modalFooterButton":"ModalNotes_modalFooterButton__2w3ia"};